import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=65ffb99a&scoped=true"
import script from "./Record.vue?vue&type=script&lang=ts"
export * from "./Record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ffb99a",
  null
  
)

export default component.exports